import { render, staticRenderFns } from "./OrganismServiceDataManagement.vue?vue&type=template&id=f25f5a90&scoped=true&"
import script from "./OrganismServiceDataManagement.vue?vue&type=script&lang=js&"
export * from "./OrganismServiceDataManagement.vue?vue&type=script&lang=js&"
import style0 from "./OrganismServiceDataManagement.vue?vue&type=style&index=0&id=f25f5a90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25f5a90",
  null
  
)

export default component.exports